import styled from '@emotion/styled'
import { MarketPlaceProperties } from '@pubstack/common/src/bidderCatalog'
import { MarketplaceBidder } from '@pubstack/common/src/marketplaceBidder'
import { FunctionComponent, useState } from 'react'
import Button from '~/components/Button'
import { useGlobalModal } from '~/components/layout/GlobalModal'
import { normalizeAsTrackingLabel } from '~/components/layout/ProductTrackingIntegration'
import { Modal } from '~/components/Modal'
import { LegalInformation, PureMarketplaceLegalInfos } from './PureMarketplaceLegalInfos'

const LegalModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const IntegrationConfirmLegalModal: FunctionComponent<{
  marketplaceProperties: MarketPlaceProperties
  bidderDisplayName: string
  bidderCode: string
  onActivateMarketplace: (bidder: MarketplaceBidder) => Promise<void>
}> = ({ marketplaceProperties, bidderDisplayName, bidderCode, onActivateMarketplace }) => {
  const { close } = useGlobalModal()
  const [isLegalInfoOpen, setIsLegalInfoOpen] = useState<boolean>(false)
  const onLegalInfosClick = () => {
    setIsLegalInfoOpen(!isLegalInfoOpen)
  }
  return (
    <Modal.Content>
      <Modal.Title>{isLegalInfoOpen ? `${bidderDisplayName}: Legal information` : 'Activate Marketplace'}</Modal.Title>
      <Modal.Body>
        {!isLegalInfoOpen ? (
          <LegalModalWrapper>
            <p>Before activating Marketplace, you should acknowledge the following information: </p>
            <PureMarketplaceLegalInfos marketplaceProperties={marketplaceProperties} bidderCode={bidderCode} onLegalInfosClick={onLegalInfosClick} />
          </LegalModalWrapper>
        ) : (
          <LegalInformation marketplaceProperties={marketplaceProperties} />
        )}
      </Modal.Body>
      <Modal.Actions>
        {!isLegalInfoOpen ? (
          <>
            <Button variant={'tertiary'} onClick={close} trackingLabel={`marketplace-activation-enabled-${bidderCode}-close`}>
              Cancel
            </Button>
            <Button
              variant={'primary'}
              onClick={() => {
                onActivateMarketplace({ marketplace: marketplaceProperties, activated: false, id: bidderCode, name: bidderDisplayName })
                close()
              }}
              trackingLabel={`marketplace-activation-enabled-${bidderCode}-confirm`}
            >
              Validate
            </Button>
          </>
        ) : (
          <Button variant={'tertiary'} onClick={() => setIsLegalInfoOpen(false)} trackingLabel={`marketplace-legal-information-${normalizeAsTrackingLabel(bidderCode)}-close`}>
            back
          </Button>
        )}
      </Modal.Actions>
    </Modal.Content>
  )
}
